<template>
  <div>
    <div v-if="$auth.loggedIn" v-qa="'login_authorized_menu'" v-click-away="hideProfile" class="login__authorized">
      <div class="login__authorized__handle sf-fr" @click="toggleProfile">
        {{ clientName }}
        <div :class="{ opened: profileNav }" class="login__authorized__caret sf-ml-xs"/>
      </div>

      <sf-slide-toggle v-model="profileNav" class="login__authorized__menu">
        <profile-links/>
      </sf-slide-toggle>
    </div>
    <sf-button v-else v-qa="'btn_login'" :url="localePath(WEB_ROUTES.LOGIN)" class="secondary sm login__button">
      {{ $t('header.login-btn') }}
    </sf-button>
  </div>
</template>

<script>
import ProfileLinks from '~/components/header/profile-links';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default {
  components: { ProfileLinks },
  data: () => ({
    profileNav: false,
  }),
  computed: {
    WEB_ROUTES() {
      return WEB_ROUTES;
    },
    clientName() {
      const { firstName, email = '' } = this.$client.profile;
      return firstName || email.split('@')[0];
    },
  },
  watch: {
    $route() {
      this.profileNav = false;
    },
  },
  methods: {
    toggleProfile() {
      this.profileNav = !this.profileNav;
    },
    hideProfile() {
      this.profileNav = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  &__authorized {
    position: relative;

    &__handle {
      color: map-get($map: $colors, $key: primary);
      font-weight: 700;
      cursor: pointer;

      @include mobile {
        display: none;
      }

      @include tablet-only {
        pointer-events: none;
      }
    }

    &__caret {
      $borderColor: map-get($colors, primary);
      @include square(16px);
      position: relative;
      top: -4px;
      border: 2px solid;
      border-color: transparent $borderColor $borderColor transparent;
      transform: rotate(45deg);
      transition: all 0.3s ease-in-out;
      transform-origin: center;

      &.opened {
        top: 4px;
        transform: rotate(-135deg);
      }

      @include tablet-only {
        display: none;
      }
    }

    &__menu {
      position: absolute;
      top: calc(100% + 10px);
      right: 0;
      z-index: 1;
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
